export const PROJECTED_CREDIT_LIMIT_MESSAGE =
  'These files would exceed your credit limit. Remove documents or contact your administrator.';

export function stagedPagesFromFiles(files: Array<{ numberOfPages?: number | null }> | undefined): number {
  return (files ?? []).reduce((total, file) => total + (file.numberOfPages ?? 0), 0);
}
